
import PropTypes from 'prop-types';
import { useState, useCallback , useEffect} from 'react';
import { useSelector } from 'react-redux';
import { Container, useTheme, TableContainer, Card, Table, TableBody, TableCell, TableRow, Button, Tabs, Tab, alpha, Box, Dialog, DialogActions, FormControl, FormGroup, FormControlLabel, Switch} from '@mui/material';
import { useSettingsContext } from '../../../../components/settings/index.js';
import {useTable, TableHeadCustom, TablePaginationCustom} from '../../../../components/table/index.js';
import CustomBreadcrumbs from '../../../../components/custom-breadcrumbs/index.js';
import {RouterLink} from '../../../../routes/components/index.js';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSnackbar } from '../../../../components/snackbar/index.js';
import { PDFViewer } from '@react-pdf/renderer';
import { useBoolean } from '../../../../hooks/use-boolean.js';
import Iconify from '../../../../components/iconify/iconify.js';
import CourseSummaryReportTableRow from './courseSummary-report-table-row.js';
import CourseSummaryReportTableToolBar from './courseSummary-report-table-toolbar.js';
import CourseSummaryPDF from './courseSummary-view-pdf.js';
import Label from '../../../../components/label/index.js';
import Scrollbar from 'src/components/scrollbar/scrollbar.js';
// import { GET_CLASS_SUMMARY } from "../../../../graphql/modules/users.js";
import ReportGraph from '../reportgraphq/report-graph.js';



// GRAPHQL
import { GET_COURSE_SUMMARY } from "../../../../graphql/modules/_client/class.js";
 import { useQuery } from "@apollo/react-hooks";

const STATUS_OPTION = [
  {value: '', label: 'All', role: ['superadmin','admin', 'bo', 'tm', 'ta']}
  // {value: 'Confirmed', label: 'Confirmed', role: ['superadmin','admin', 'bo', 'tm', 'ta']},
  // {value: 'Completed', label: 'Completed', role: ['superadmin','admin', 'bo', 'tm', 'ta']},
  // {value: 'Draft', label: 'Draft', role: ['superadmin','admin', 'bo', 'tm']},
  // {value: 'Cancelled', label: 'Cancelled', role: ['superadmin','admin', 'bo', 'tm']},
]
// const STATUS_OPTION_TA = [
//   {value: 'all', label: 'All'},
//   {value: 'confirmed', label: 'Confirmed'},
//   {value: 'completed', label: 'Completed'},
// ]
const TABLE_HEAD = [
  {id: '_id', label: 'Course Title'},
  {id: 'totalConfirmedClasses', label: 'Total Confirmed Classes'},
  {id: 'totalCompleted', label: 'Total Completed Classes'},
  {id: 'totalDraftClasses', label: 'Total Draft Classes'},
  {id: 'totalClasses', label: 'Total Classes'},
  {id: 'countConfirmedTrainee' || 'countDraftTrainee', label: 'Total Trainees'},
]

const defaultFilters = {
  name: '',
  dateFrom: null,
  dateTo: null,
  status: ''
}

export function CourseSummaryListViewReport({companyinfo}) {
  const {fullName} = useSelector((state) => state?.auth?.user);
  const {nricFin} = useSelector((state) => state?.auth?.user);
  const company = useSelector((state) => state?.auth?.company);
  const isRole = useSelector((state) => state?.auth?.isRole);
  const companyProfile = useSelector((state) => state?.auth?.companyProfile?.companyProfile);
  const company_name  = useSelector((state) => state?.auth?.companyProfile?.companyProfile?.companyName);
  const { state } = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();
  const classSummaryDG = useBoolean();
  const table = useTable();
  const navigate = useNavigate();
  const settings = useSettingsContext();
  const [filters, setFilters] = useState('');
  const [searchText, setSearch] = useState(defaultFilters);
  const [companyName, setCompanyName] = useState("iatos");
  const [page, setPage] = useState(1);
  const [results, setResults] = useState(null);
  const [classAtt, setClassAtt] = useState(null);
  const [trainer, setTrainer] = useState(null);
    const [switchGraph, setSwitchGraph] = useState(false);


  const [total, setTotal] = useState({
    totalConfirmed: 0,
    totalCompleted: 0,
    totalDraft: 0,
    totalClasses: 0,
    totalTrainee: 0,
    totalTraineeDraft: 0
  })


  const { data, loading, error, refetch } = useQuery(GET_COURSE_SUMMARY, {
    variables: {
      limit: table?.rowsPerPage,
      offset: table?.page,
      searchText: searchText,
      companyName: state?.databaseName || company,
      order: table.order || 'desc',
      orderBy: table.orderBy || '_id',
      filterBy: nricFin,
      isRole: isRole
      },
      fetchPolicy: "cache-and-network",
    });

    useEffect(() => {
      if(data){
        setResults(data?.getCourseSummary)
        // setTrainer(trainerInfo?.getTrainerAssessor)
       const totalConfirmed  = data?.getCourseSummary?.results?.reduce((acc, item) => acc + item.totalConfirmedClasses, 0);
       const totalCompleted  = data?.getCourseSummary?.results?.reduce((acc, item) => acc + item.totalCompletedClasses, 0);
       const totalDraft  = data?.getCourseSummary?.results?.reduce((acc, item) => acc + item.totalDraftClasses, 0);
       const totalClasses  = data?.getCourseSummary?.results?.reduce((acc, item) => acc + item.totalClasses, 0);
       const totalTrainee  = data?.getCourseSummary?.results?.reduce((acc, item) => acc + item.countConfirmedTrainee, 0);
       const totalDraftTrainee = data?.getCourseSummary?.results?.reduce((acc, item) => acc + item.countDraftTrainee, 0);

        setTotal({
          totalConfirmed: totalConfirmed,
          totalCompleted: totalCompleted,
          totalDraft: totalDraft,
          totalClasses: totalClasses,
          totalTrainee: totalTrainee,
          totalTraineeDraft: totalDraftTrainee
        })
      }
  }, [data])

  

  const handleFilters = useCallback((name, value) => {
    setSearch(prevState => ({
      ...prevState, 
      [name]: value 
    }));
  },[table]
);
  


    
    const handleFilterStatus = useCallback(
      (event, newValue) => {
        if(newValue !== "all"){
          setSearch(prevState => ({
            ...prevState, 
            "status": newValue 
          }));
          setFilters(newValue);
        }else {
          setFilters(newValue);
          setSearch('');
        }

      },
      [table]
    );

  

  const handleViewAccount = useCallback((row) => {
      navigate('/company-view-account', {state: row})
    },
    []
  );
  const handleEditRow = useCallback((row) => {
      navigate('/company-create-update-classes', {state: {info: companyinfo, classInfo: row}})
  });

const handleView = useCallback(
  (row) => {
    setClassAtt(row)
  },
  []
);

const handleCreateNewClass = useCallback(() => {
    navigate(`/${company}/reports`, {state: {info: companyinfo}})

});


const handleReset = useCallback(async() => {
  setSearch(defaultFilters);
  setFilters('')
}, [setSearch])

const handlePrintClassSummary = useCallback(async() => {
    const getAll = await refetch({
      limit: results?.count,
      offset: 0,
      searchText: searchText,
      companyName: state?.databaseName || company,
      order: table.order || 'desc',
      orderBy: table.orderBy || '_id',
      filterBy: nricFin,
      isRole: isRole
    })
    if(getAll?.data){
      setClassAtt(getAll?.data?.getCourseSummary?.results)
      classSummaryDG.onTrue();
    }
});

const handleSwitchChange = (event) => {
      setSwitchGraph(event.target.checked);
};




  return (
     <Container maxWidth={settings.themeStretch ? false : 'xl'}>
        <CustomBreadcrumbs
          heading={`${companyinfo?.companyName || company_name} - Course Breakdown Summary Report`}
          links={[
           {name: 'Dashboard'},
           {name: 'Course Breakdown Summary Report'}
          ]}
          action ={
          <>
           <FormControl component="fieldset">
              <FormGroup aria-label="position">
                  <FormControlLabel
                      value="bottom"
                      control={<Switch color="primary" onChange={handleSwitchChange} />}
                      label={!switchGraph ? "Switch to Graph" : "Switch to Table"}
                          labelPlacement="bottom"
                    />
                </FormGroup>
            </FormControl>
           <Button
           componet={RouterLink}
           onClick={handleCreateNewClass}
           variant="contained"
           startIcon={<Iconify icon="mingcure:add-line" />}
           sx={{
            display: isRole.some((role)=> ["bo", "tm"].includes(role)) ?  '' : 'none'
           }}
           >
            Go Back
          </Button>
          </>
        }
       />

        { 
       !switchGraph ?  

        <Card>
         <Tabs 
          value={filters}
          onChange={handleFilterStatus}
          sx={{
            px: 2.5,
            boxShadow: (theme) => `inset 0 -2px 0 0 ${alpha(theme.palette.grey[500], 0.08)}`
          }}
         >
          {STATUS_OPTION.map((tab) => (
            <Tab
              key={tab?.value}
              iconPosition='end'
              value={tab?.value}
              label={tab?.label}
              icon={
              <Label 
                variant={
                  ((tab.value === '' || tab.value === filters.status) && 'filled') || 'soft'
                }
                color={
                  (tab.value === 'Confirmed' && 'success') ||  (tab.value === 'Completed' && 'info') ||  (tab.value === 'Draft' && 'warning')  ||  (tab.value === 'Cancelled' && 'error') || 'default'
                }
                >
                  {tab.value === '' && results?.count}
              </Label>
              }
              sx={{
                display: isRole.some((role)=> tab?.role?.includes(role)) ? '' : 'none'
              }}
           />
  
          ))}

         </Tabs>
 
          <CourseSummaryReportTableToolBar onFilters={handleFilters} handlePrintClassSummary={() => handlePrintClassSummary()} trainer={trainer} handleReset={handleReset} searchText={searchText}/>
          <Scrollbar>
          <TableContainer sx={{ position: 'relative', overflow: 'unset'}}>
              <Table  sx={{minWidth: 960}}>
                
              <TableHeadCustom
                headLabel={TABLE_HEAD}
                order={table.order}
                orderBy={table.orderBy}
                onSort={table.onSort}
              />
  

   
                <TableBody>

                {results?.results?.map((row) => (
                      <CourseSummaryReportTableRow
                      key={row?.id}
                      row={row}
                      onViewRow={() => handleView(row)}
                      // onDeleteRow={() => handleDeleteRow(row)}
                      // onEditRow={() => handleEditRow(row)}
                      // onCancelledRow={() => handleCancelledRow(row)}
                      // onCompleted={() => handleCompleted(row)}
                      // onRevert={() => handleRevertBack(row)}
                    />
                ))}
                  <TableRow>
                  <TableCell>Total</TableCell>
                  <TableCell>{total?.totalConfirmed}</TableCell>
                  <TableCell>{total?.totalCompleted}</TableCell>
                  <TableCell>{total?.totalDraft}</TableCell>
                  <TableCell>{total?.totalClasses}</TableCell>
                  <TableCell>{total?.totalTrainee || total?.totalTraineeDraft}</TableCell>
                </TableRow>

                </TableBody>

              </Table>
          </TableContainer>
          </Scrollbar>

          <TablePaginationCustom 
            count={results?.count}
            page={table.page}
            rowsPerPage={table.rowsPerPage}
            onPageChange={table.onChangePage}
            onRowsPerPageChange={table.onChangeRowsPerPage}
          />
        </Card>

          :
          <ReportGraph
            title="Course Breakdown Summary Report"
            chart={{
              categories: [
                'Total Confirmed Classes',
                'Total Complete Classes',
                'Total Draft Classes',
                'Total Classes',
                'Total Trainees'
              ],
              series: [
                {
                  year: '2024',
                  data: results?.results?.map((item) => (
                    {name: item?._id, data: [item?.totalConfirmedClasses, item?.totalCompletedClasses, item?.totalDraftClasses, item?.totalClasses, item?.countConfirmedTrainee]}
                  )) 
                }
              ]
            }}
            onFilters={handleFilters} 
            searchText={searchText}
          />

      }

        <Dialog fullScreen open={classSummaryDG.value}>
        <Box sx={{ height: 1, display: 'flex', flexDirection: 'column' }}>
          <DialogActions
            sx={{
              p: 1.5,
            }}
          >
            <Button color="inherit" variant="contained" onClick={classSummaryDG.onFalse}>
              Close
            </Button>
          </DialogActions>

          <Box sx={{ flexGrow: 1, height: 1, overflow: 'hidden' }}>
            <PDFViewer width="100%" height="100%" style={{ border: 'none' }}>
              <CourseSummaryPDF course={classAtt} total={total} companyProfile={companyProfile} searchText={searchText}/>
            </PDFViewer>
          </Box>
        </Box>
      </Dialog>

    </Container>
  );
}

CourseSummaryListViewReport.propTypes = {
  companyinfo: PropTypes.object,
};